function parseCredits(value) {
    const normalizedValue = String(value ?? '').replace(/[^\d-]/g, '');
    const credits = Number.parseInt(normalizedValue, 10);

    return Number.isFinite(credits) ? Math.max(0, credits) : null;
}

function updateProfileMenuCredits(credits) {
    const formatter = new Intl.NumberFormat(document.documentElement.lang || undefined);
    const formattedCredits = formatter.format(credits);

    document.querySelectorAll('.user-profile-panel__credits').forEach((panel) => {
        let creditGoal = Math.max(1, Number.parseInt(panel.dataset.creditGoal || '100', 10));

        if (credits > creditGoal) {
            creditGoal = credits;
            panel.dataset.creditGoal = String(creditGoal);
        }

        const progress = Math.min(100, (credits / creditGoal) * 100);
        const amount = panel.querySelector('.user-profile-panel__credits-amount');
        const progressValue = panel.querySelector('.user-profile-panel__progress-value');
        const copy = panel.querySelector('.user-profile-panel__credits-copy');

        if (amount) {
            amount.textContent = formattedCredits;
        }

        if (progressValue) {
            progressValue.style.width = `${progress}%`;
        }

        if (copy) {
            const copyTemplate = panel.dataset.creditCopyTemplate || '%s credits ready to spend';
            copy.textContent = copyTemplate.replace('%s', formattedCredits);
        }
    });
}

function initProfileMenuCredits() {
    const creditSources = document.querySelectorAll('.growtype-chat-credits .growtype-chat-credits-amount');

    if (!document.querySelector('.user-profile-panel__credits')) {
        return;
    }

    const syncFromSource = (source) => {
        const credits = parseCredits(source.textContent);

        if (credits !== null) {
            updateProfileMenuCredits(credits);
        }
    };

    if (creditSources.length) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => syncFromSource(mutation.target));
        });

        creditSources.forEach((source) => {
            observer.observe(source, {
                childList: true,
                characterData: true,
                subtree: true,
            });
        });

        syncFromSource(creditSources[0]);
    }

    const apiClient = window.talkiemateApiV2Client;
    if (apiClient && typeof apiClient.bootstrap === 'function') {
        apiClient.bootstrap().then((bootstrap) => {
            const credits = Number.parseInt(bootstrap?.entitlements?.credits?.total, 10);
            if (Number.isFinite(credits) && credits >= 0) {
                updateProfileMenuCredits(credits);
            }
        }).catch(() => {
            // The existing DOM source remains the compatibility fallback.
        });
    }
}

function profileMenuCredits() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProfileMenuCredits, { once: true });
        return;
    }

    initProfileMenuCredits();
}

export { profileMenuCredits };
